// External Libraries
import * as React from "react";

// Components
import { ModuleTitle } from "components/flexComponents/Hotels/components/ModuleTitle";
import { LegalText } from "components/flexComponents/Hotels/components/LegalText";
import { HotelStarRatingAffinityFilters } from "components/flexComponents/Hotels/components/HotelAffinityFilters/HotelStarRatingAffinityFilters";

// Utils
import { useLocalization } from "@shared-ui/localization-context";
import { useHotelsContext } from "components/flexComponents/Hotels/components/HotelsContext";
import { getStarRating } from "components/utility/ContextUtil";

export const SummarizedHotelsCommonView: React.FC<{}> = ({ children }) => {
  const { formatText } = useLocalization();
  const { flexComponent, context } = useHotelsContext();
  const model = flexComponent.model;
  const hotelsStarRating = model.starRating;

  const regionName: string = model.locationName;

  const pageStarRating = getStarRating(context);

  const headingKey =
    hotelsStarRating && hotelsStarRating === 1
      ? "hotels.affinity.starRating.similar.title.one"
      : "hotels.affinity.starRating.similar.title.other";
  const subHeadingKey =
    hotelsStarRating && hotelsStarRating === 1
      ? "hotels.affinity.starRating.similar.subtitle.one"
      : "hotels.affinity.starRating.similar.subtitle.other";

  const heading = hotelsStarRating ? formatText(headingKey, hotelsStarRating) : model.title;
  const subHeading = hotelsStarRating
    ? formatText(subHeadingKey, hotelsStarRating, pageStarRating, regionName)
    : model.subTitle;

  return (
    <>
      <ModuleTitle heading={heading} subHeading={subHeading} />
      {children}
      <HotelStarRatingAffinityFilters />
      <LegalText className="all-t-padding-two" />
    </>
  );
};
